import React, { useContext, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faBell } from "@fortawesome/free-solid-svg-icons";
import Sidebar_List from "./sidebar_list/Sidebar_List";
import Notification_Offcanvas from "../common_components/common_offcanvas/notification_offcanvas/Notification_Offcanvas";
import { Context } from "../../utils/context";
import "./Sidebar.css";

const Sidebar = () => {
  const { userdata, signin, headerCompanyName } = useContext(Context);

  const [showSidebar, setShowSidebar] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);

  const handleSidebarClose = () => setShowSidebar(false);
  const handleSidebarShow = () => setShowSidebar(true);

  const handleNotificationsClose = () => setShowNotifications(false);
  const handleNotificationsShow = () => setShowNotifications(true);

  return (
    <>
      {/* Desktop Sidebar – visible from 1280px and up */}
      <aside
        className="
          fixed left-0 top-0
          max-[1281px]:hidden
          h-screen w-72 pt-16
          bg-gradient-to-b from-slate-950 via-slate-900 to-black
          border-r border-cyan-900/30
          flex flex-col z-40 shadow-2xl overflow-hidden
        "
      >
        <nav className="flex-1 px-4 py-8 overflow-y-auto">
          <Sidebar_List
            handleClose={handleSidebarClose}
            onNotificationClick={handleNotificationsShow}
          />
        </nav>

        <div className="p-6 border-t border-cyan-900/20">
          <button
            onClick={handleNotificationsShow}
            className="
              w-full h-14 rounded-2xl
              bg-gradient-to-r from-cyan-900/30 to-blue-900/20
              hover:from-cyan-800/40 hover:to-blue-800/30
              flex items-center justify-center gap-3
              transition-all duration-300
              hover:shadow-lg hover:shadow-cyan-500/20 hover:scale-[1.02]
              border border-cyan-700/40
            "
          >
            <FontAwesomeIcon icon={faBell} className="text-xl text-cyan-400" />
            <span className="text-white font-medium tracking-wide">Notifications</span>
          </button>
        </div>
      </aside>

      {/* Hamburger Button – visible below 1280px */}
      <button
        onClick={handleSidebarShow}
        className="
          fixed min-[1281px]:hidden
          top-16 left-3 z-50
          w-14 h-12 rounded-2xl
          bg-gradient-to-br from-slate-900 to-black
          border border-cyan-900/40
          flex items-center justify-center
          transition-all duration-300
          hover:scale-110 hover:shadow-2xl hover:shadow-cyan-500/30
        "
      >
        <FontAwesomeIcon icon={faBars} className="text-2xl text-cyan-400" />
      </button>

      {/* Mobile Sidebar Offcanvas */}
      <Offcanvas
        show={showSidebar}
        onHide={handleSidebarClose}
        placement="start"
        className="w-80 bg-gradient-to-b from-slate-950 via-slate-900 to-black backdrop-blur-xl border-r border-cyan-900/30"
      >
        <Offcanvas.Header
          closeButton
          className="border-b border-cyan-900/30 px-6 py-4 bg-slate-950/80 mt-5"
          closeVariant="white"
        />

        <Offcanvas.Body className="p-0 flex flex-col">
          <nav className="flex-1 px-4 py-8">
            <Sidebar_List
              handleClose={handleSidebarClose}
              onNotificationClick={handleNotificationsShow}
            />
          </nav>

          <div className="p-6 border-t border-cyan-900/30">
            <button
              onClick={() => {
                handleNotificationsShow();
                handleSidebarClose();
              }}
              className="
                w-full h-14 rounded-2xl
                bg-gradient-to-r from-cyan-900/30 to-blue-900/20
                hover:from-cyan-800/40 hover:to-blue-800/30
                flex items-center justify-center gap-3
                transition-all duration-300
                hover:shadow-lg hover:shadow-cyan-500/20 hover:scale-[1.02]
                border border-cyan-700/40
              "
            >
              <FontAwesomeIcon icon={faBell} className="text-xl text-cyan-400" />
              <span className="text-white font-medium tracking-wide">Notifications</span>
            </button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      {/* Notifications Offcanvas */}
      <Notification_Offcanvas
        show={showNotifications}
        onHide={handleNotificationsClose}
      />
    </>
  );
};

export default Sidebar;